export const eventPrefix = "GrowthExperiment__";
export const messageIdentifier = "growthExperiment";
